import { render, staticRenderFns } from "./iddstation.vue?vue&type=template&id=10bc2b22&scoped=true&"
import script from "./iddstation.vue?vue&type=script&lang=js&"
export * from "./iddstation.vue?vue&type=script&lang=js&"
import style0 from "./iddstation.vue?vue&type=style&index=0&id=10bc2b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc2b22",
  null
  
)

export default component.exports